export enum Pages {
  Game = 'game',
  Reference = 'reference',
}

export type GameMode = 'letters' | 'words' | 'numbers-signs' | 'draw-letter' | 'draw-word';
